import { Pipe, type PipeTransform } from '@angular/core';
import { toLocalISO } from '@quipex/core/primitives';

@Pipe({
    name: 'qpxToLocalISO',
})
export class ToLocalISOPipe implements PipeTransform {
    /**
     * Transforms a Date object into an ISO string with the system's local time zone.
     * Falls back to current date/time if invalid.
     */
    transform(value: Date): string {
        if (!(value instanceof Date) || isNaN(value.getTime())) {
            return toLocalISO();
        }
        try {
            return toLocalISO(value);
        } catch {
            return toLocalISO();
        }
    }
}
